import { ICommandBarItemProps } from '@fluentui/react';
import { useAppConfig } from '@msrceng/auth';
import { ISugConfig } from 'config/shared';

export const useApiButtonItemProps = (): ICommandBarItemProps => {
  const { apiDocsUrl } = useAppConfig<ISugConfig>();

  return {
    key: 'apiButton',
    text: 'API',
    iconProps: { iconName: 'Code' },
    href: apiDocsUrl,
    target: '_blank',
    title: `API Swagger JSON file: ${apiDocsUrl}`,
  };
};
